export enum Airtable {
  UTILISATEURS = 'FCU - Utilisateurs',
  RELANCE = 'FCU - Utilisateurs relance',
  CONTACT = 'FCU - Formulaire de contact',
  COMMUNES_SANS_RESEAU = 'FCU - Formulaire communes sans reseau',
  NEWSLETTER = 'FCU - Newsletter',
  CONTRIBUTION = 'FCU - Contribution',
  CONNEXION = 'FCU - Connexion espace gestionnaire',
  COMPTES_PRO = 'FCU - Comptes pro',
  GESTIONNAIRES = 'FCU - Gestionnaires',
  GESTIONNAIRES_API = 'FCU - Gestionnaires API',
  NETWORKS = 'FCU - Réseaux de chaleur',
  COLD_NETWORKS = 'FCU - Réseaux de froid',
  FUTUR_NETWORKS = 'FCU - Futur réseaux de chaleur',
  MODIFICATIONS_RESEAU = 'FCU - Modifications réseau',
  DEMANDES_ELIGIBILITES = 'FCU - test en masse',
  UTILISATEURS_EMAILS = 'FCU - Utilisateurs emails',
}
